import SvgRoutingPipelines from "../../../../pipy/docs/tutorial/routing-pipelines.svg";
import * as React from 'react';
export default {
  SvgRoutingPipelines,
  React
};